(function () {
  'use strict';
  var ASSIGNMENTS = '_ddey_vessel_assignments';
  var GROUP = '_ddey_vessel_group';
  function clean(value) { return typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 160) : ''; }
  function size(value) { var n = Number(value); return Number.isSafeInteger(n) && n > 0 ? n : 1; }
  function readNames(properties, quantity) {
    properties = properties || {};
    var names;
    try { names = JSON.parse(properties[ASSIGNMENTS]); } catch (_) {}
    return Array.from({ length: size(quantity) }, function (_, i) {
      return clean(Array.isArray(names) ? names[i] : properties['Vessel for kit ' + (i + 1)] || properties['Vessel name'] || properties.vessel_name || '');
    });
  }
  function makeProperties(original, names, group) {
    var result = Object.assign({}, original || {});
    Object.keys(result).forEach(function (key) {
      if (/^Vessel for kit \d+$/.test(key) || key === 'Vessel name' || key === ASSIGNMENTS) delete result[key];
    });
    names = names.map(clean);
    result[ASSIGNMENTS] = JSON.stringify(names);
    result[GROUP] = group;
    names.forEach(function (name, i) { if (name) result['Vessel for kit ' + (i + 1)] = name; });
    return result;
  }
  var helpers = { clean: clean, readNames: readNames, makeProperties: makeProperties, ASSIGNMENTS: ASSIGNMENTS, GROUP: GROUP };
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof document === 'undefined') return;

  var config = document.getElementById('DdeyKitVesselConfig');
  if (!config) return;
  var text = config.dataset;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var cartStates = new Map();
  var serial = 0;
  var saveChain = Promise.resolve();
  var replayingCheckout = false;
  var refreshTimer;
  var datalist = document.createElement('datalist');
  datalist.id = 'DdeyVesselSuggestions';
  document.body.appendChild(datalist);
  function uniqueGroup() { return 'vessel-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2); }
  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }
  function suggestions() {
    var names = new Set();
    document.querySelectorAll('[data-ddey-vessel-input]').forEach(function (input) { if (clean(input.value)) names.add(clean(input.value)); });
    datalist.replaceChildren();
    names.forEach(function (name) { var option = element('option'); option.value = name; datalist.appendChild(option); });
  }
  function status(state, message, isError) {
    var node = state.node.querySelector('[data-ddey-vessel-status]');
    if (node) { node.textContent = message; node.dataset.error = isError ? 'true' : 'false'; }
  }
  function updateCheckoutState() {
    var dirty = Array.from(cartStates.values()).some(function (state) { return state.dirty && state.node.isConnected; });
    document.body.toggleAttribute('data-ddey-vessels-unsaved', dirty);
    // Accelerated cart buttons can live in iframes. Don't let them race an unsaved edit.
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (node) {
      if (dirty && !node.inert) { node.inert = true; node.dataset.ddeyVesselInert = 'true'; }
      else if (!dirty && node.dataset.ddeyVesselInert === 'true') { node.inert = false; delete node.dataset.ddeyVesselInert; }
    });
  }
  function collect(state) { return Array.from(state.node.querySelectorAll('[data-ddey-vessel-input]')).map(function (input) { return clean(input.value); }); }
  function drawFields(state, productMode) {
    var fields = state.node.querySelector('[data-ddey-vessel-fields]');
    fields.replaceChildren();
    state.names.forEach(function (name, i) {
      var id = 'DdeyVessel-' + state.id + '-' + i;
      var label = element('label', '', state.names.length === 1 ? text.singleLabel : text.unitLabel.replace('__NUMBER__', String(i + 1)));
      label.htmlFor = id;
      var input = element('input');
      input.id = id; input.type = 'text'; input.value = name; input.maxLength = 160; input.autocomplete = 'off';
      input.setAttribute('data-ddey-vessel-input', ''); input.setAttribute('list', datalist.id);
      if (productMode) input.name = 'properties[Vessel for kit ' + (i + 1) + ']';
      fields.append(label, input);
    });
    state.node.querySelector('[data-ddey-copy-vessel]').hidden = state.names.length < 2;
    suggestions();
  }
  function resize(state, quantity, productMode) {
    state.names = Array.from({ length: size(quantity) }, function (_, i) { return state.names[i] || ''; });
    drawFields(state, productMode);
  }
  function markDirty(state) {
    state.names = collect(state); state.version += 1; state.dirty = true;
    status(state, text.unsaved); suggestions(); updateCheckoutState();
    clearTimeout(state.timer);
    state.timer = setTimeout(function () { saveAll().catch(function () {}); }, 650);
  }
  function wireCopy(state, productMode, changed) {
    state.node.querySelector('[data-ddey-copy-vessel]').addEventListener('click', function () {
      state.names = collect(state); state.names.fill(state.names[0] || '');
      drawFields(state, productMode); changed();
    });
  }
  document.querySelectorAll('[data-ddey-product-vessels]').forEach(function (node) {
    var form = node.closest('form');
    if (!form) return;
    var state = { node: node, id: ++serial, names: [clean(node.querySelector('[data-ddey-vessel-input]').value)] };
    var hidden = element('input'); hidden.type = 'hidden'; hidden.name = 'properties[' + ASSIGNMENTS + ']';
    var group = element('input'); group.type = 'hidden'; group.name = 'properties[' + GROUP + ']'; group.value = uniqueGroup();
    form.append(hidden, group);
    function sync() { state.names = collect(state); hidden.value = JSON.stringify(state.names); suggestions(); }
    var quantity = form.querySelector('[name="quantity"]');
    resize(state, quantity ? quantity.value : 1, true); sync();
    node.addEventListener('input', sync);
    wireCopy(state, true, sync);
    if (quantity) {
      quantity.addEventListener('input', function () { state.names = collect(state); resize(state, quantity.value, true); sync(); });
      quantity.addEventListener('change', function () { state.names = collect(state); resize(state, quantity.value, true); sync(); });
    }
    // A unique property prevents repeated additions from merging mismatched unit arrays.
    form.addEventListener('submit', function () { sync(); group.value = uniqueGroup(); }, true);
    form.addEventListener('click', function (event) {
      if (event.target.closest('[name="add"], [data-add-to-cart], .shopify-payment-button')) { sync(); group.value = uniqueGroup(); }
    }, true);
  });

  var eligibilityNode = document.getElementById('DdeyCartVesselEligibility');
  if (!eligibilityNode) return;
  var eligibility = {};
  try { eligibility = JSON.parse(eligibilityNode.textContent); } catch (_) {}
  var cartList = document.querySelector('[data-cart-line-items]');
  if (!cartList) return;
  async function fetchCart() {
    var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart not available');
    return response.json();
  }
  function identity(item) { return item.properties && item.properties[GROUP] || item.key; }
  function buildCartNode(state) {
    var node = element('fieldset', 'ddey-kit-vessels');
    node.setAttribute('data-ddey-cart-vessels', '');
    node.append(element('legend', '', text.heading), element('p', 'ddey-kit-vessels__help', text.help));
    var fields = element('div'); fields.setAttribute('data-ddey-vessel-fields', ''); node.append(fields);
    var copy = element('button', 'ddey-kit-vessels__copy', text.copy); copy.type = 'button'; copy.setAttribute('data-ddey-copy-vessel', ''); node.append(copy);
    var save = element('button', 'ddey-kit-vessels__save', text.save); save.type = 'button'; node.append(save);
    var message = element('p', 'ddey-kit-vessels__status'); message.setAttribute('data-ddey-vessel-status', ''); message.setAttribute('role', 'status'); message.setAttribute('aria-live', 'polite'); node.append(message);
    state.node = node;
    node.addEventListener('input', function (event) { if (event.target.matches('[data-ddey-vessel-input]')) markDirty(state); });
    wireCopy(state, false, function () { markDirty(state); });
    save.addEventListener('click', function () { saveAll().catch(function () {}); });
    return node;
  }
  async function refresh() {
    try {
      var cart = await fetchCart();
      var oldWarning = document.getElementById('DdeyVesselLoadError');
      if (oldWarning) oldWarning.remove();
      document.querySelectorAll('[data-cart-item]').forEach(function (row) {
        var item = cart.items.find(function (candidate) { return candidate.key === row.getAttribute('data-cart-item-key'); });
        if (!item || (!eligibility[item.variant_id] && !(item.properties && item.properties[ASSIGNMENTS]))) return;
        var key = identity(item);
        var state = cartStates.get(key);
        if (!state) {
          state = { id: ++serial, key: item.key, group: item.properties && item.properties[GROUP] || '', variantId: item.variant_id, names: readNames(item.properties, item.quantity), version: 0, dirty: false };
          cartStates.set(key, state);
          buildCartNode(state);
        }
        state.key = item.key;
        // The editable panel is authoritative; avoid stale duplicated vessel text
        // in Debut's native property summary after an AJAX property-only save.
        row.querySelectorAll('[data-cart-item-property]').forEach(function (property) {
          var label = property.querySelector('[data-cart-item-property-name]');
          if (label && /^(Vessel for kit \d+|Vessel name|vessel_name|_ddey_vessel_assignments|_ddey_vessel_group):\s*$/.test(label.textContent.trim())) property.classList.add('hide');
        });
        row.querySelectorAll('[data-ddey-cart-vessels]').forEach(function (node) { if (node !== state.node) node.remove(); });
        if (!row.contains(state.node)) {
          var quantityChanged = state.names.length !== item.quantity;
          (row.querySelector('[data-cart-table-cell]') || row.querySelector('td')).appendChild(state.node);
          resize(state, item.quantity, false);
          if (quantityChanged) markDirty(state);
        } else if (state.names.length !== item.quantity) {
          state.names = collect(state); resize(state, item.quantity, false);
          markDirty(state);
        }
      });
      updateCheckoutState();
    } catch (_) {
      var warning = document.getElementById('DdeyVesselLoadError');
      if (!warning) { warning = element('p', 'ddey-kit-vessels__status', text.loadingError); warning.id = 'DdeyVesselLoadError'; warning.setAttribute('role', 'alert'); cartList.closest('form').prepend(warning); }
    }
  }
  function saveAll() {
    saveChain = saveChain.catch(function () {}).then(async function () {
      var states = Array.from(cartStates.values()).filter(function (state) { return state.dirty && state.node.isConnected; });
      if (!states.length) return;
      var cart;
      try { cart = await fetchCart(); } catch (error) { states.forEach(function (state) { status(state, text.error, true); }); throw error; }
      for (var state of states) {
        clearTimeout(state.timer);
        var version = state.version;
        var item = cart.items.find(function (candidate) { return state.group ? candidate.properties && candidate.properties[GROUP] === state.group : candidate.key === state.key; });
        if (!item) { status(state, text.error, true); throw new Error('Cart line changed; refresh required'); }
        var names = Array.from({ length: item.quantity }, function (_, i) { return state.names[i] || ''; });
        var group = state.group || uniqueGroup();
        status(state, text.saving);
        try {
          var response = await fetch(root + 'cart/change.js', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: makeProperties(item.properties, names, group) })
          });
          if (!response.ok) throw new Error('Vessel assignments not saved');
          cart = await response.json();
          var updated = cart.items.find(function (candidate) { return candidate.properties && candidate.properties[GROUP] === group; });
          if (!updated) throw new Error('Saved cart line not found');
          var oldIdentity = state.group || state.key;
          state.group = group; state.key = updated.key;
          cartStates.delete(oldIdentity); cartStates.set(group, state);
          var row = state.node.closest('[data-cart-item]');
          if (row) row.setAttribute('data-cart-item-key', updated.key);
          if (state.version === version) { state.dirty = false; status(state, text.saved); }
          else status(state, text.unsaved);
        } catch (error) { status(state, text.error, true); updateCheckoutState(); throw error; }
      }
      updateCheckoutState();
      // An edit made while saving is included before checkout can continue.
      if (Array.from(cartStates.values()).some(function (state) { return state.dirty && state.node.isConnected; })) {
        clearTimeout(refreshTimer); refreshTimer = setTimeout(function () { saveAll().catch(function () {}); }, 50);
      }
    });
    return saveChain;
  }
  async function beforeCheckout(replay) {
    try {
      do { await saveAll(); } while (Array.from(cartStates.values()).some(function (state) { return state.dirty && state.node.isConnected; }));
      replayingCheckout = true; replay(); replayingCheckout = false;
    } catch (_) { replayingCheckout = false; }
  }
  var cartForm = cartList.closest('form');
  cartForm.addEventListener('click', function (event) {
    var checkout = event.target.closest('[name="checkout"], a[href="/checkout"]');
    if (!checkout || replayingCheckout || !document.body.hasAttribute('data-ddey-vessels-unsaved')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    beforeCheckout(function () { checkout.click(); });
  }, true);
  cartForm.addEventListener('submit', function (event) {
    if (replayingCheckout || !document.body.hasAttribute('data-ddey-vessels-unsaved') || !event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    var button = event.submitter;
    beforeCheckout(function () { cartForm.requestSubmit(button); });
  }, true);
  var observer = new MutationObserver(function (records) {
    if (!records.some(function (record) { return !record.target.closest('[data-ddey-cart-vessels]'); })) return;
    clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 100);
  });
  observer.observe(cartList, { childList: true, subtree: true });
  refresh();
})();
